export class ErrorWithData<T> extends Error {
    data: T;
    constructor(data: T, message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
        this.data = data;
    }
}
